import team from './team';

const modules = {
  team,
};

export default modules;
